import { computed, ref } from "@vue/composition-api";

export const UseActionToggle = (
  initial_state = false,
  on_change: (val: boolean) => void
) => {
  const _is_on = ref(initial_state);
  const is_on = computed(() => _is_on.value);
  const toggle = () => {
    _is_on.value = !_is_on.value;
    on_change(_is_on.value);
  };

  const turn_on = () => {
    _is_on.value = true;
    on_change(true);
  };

  const turn_off = () => {
    _is_on.value = false;
    on_change(false);
  };

  const set_initial = (val: boolean) => {
    _is_on.value = val;
  };

  return {
    set_initial,
    is_on,
    toggle,
    turn_on,
    turn_off,
  };
};
